var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticClass:"waterMask"},[_c('canvas',{ref:"single",staticClass:"single"}),_vm._v(" "),_c('canvas',{ref:"repeat"})])
}
var staticRenderFns = []

export { render, staticRenderFns }